import api from './api';

// Encaissements Adyen — TPE (Terminal API) + lien de paiement (backend/src/routes/encaissements.js)
const encaissementsApi = {
  contexte:     ()            => api.get('/encaissements/contexte'),
  societes:     ()            => api.get('/encaissements/societes'),
  terminaux:    (params)      => api.get('/encaissements/terminaux', { params }),
  liste:        (params)      => api.get('/encaissements', { params }),
  exportCsv:    (params)      => api.get('/encaissements/export.csv', { params, responseType: 'blob' }),
  creer:        (data)        => api.post('/encaissements', data),
  lire:         (id)          => api.get(`/encaissements/${id}`),
  events:       (id)          => api.get(`/encaissements/${id}/events`),
  modifier:     (id, data)    => api.patch(`/encaissements/${id}`, data),
  tpe:          (id, terminalId) => api.post(`/encaissements/${id}/tpe`, { terminal_id: terminalId }),
  lien:         (id, opts)    => api.post(`/encaissements/${id}/lien`, opts),
  annuler:      (id)          => api.post(`/encaissements/${id}/annuler`),
  reouvrir:     (id)          => api.post(`/encaissements/${id}/reouvrir`),
  resoudre:     (id, data)    => api.post(`/encaissements/${id}/resoudre`, data),
  // Configuration (super-admin)
  config:       ()            => api.get('/encaissements/config/tout'),
  saveCompte:   (data)        => api.post('/encaissements/config/comptes', data),
  deleteCompte: (id)          => api.delete(`/encaissements/config/comptes/${id}`),
  saveTerminal: (data)        => api.post('/encaissements/config/terminaux', data),
  deleteTerminal: (id)        => api.delete(`/encaissements/config/terminaux/${id}`),
  webhooks:     ()            => api.get('/encaissements/config/webhooks'),
  poller:       ()            => api.post('/encaissements/config/poller'),
};

export default encaissementsApi;
